import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Unchecked from 'images/icons/Unchecked.svg?react';
import { useModalStore } from 'stores/modal';
import { ModalType } from 'core/useCases/modal/types';
import ActivityType from 'core/enums/activityType';
import TaskStatus from 'core/enums/taskStatus';
import { useTaskById } from 'core/api/tasks';
import Button from 'components/Button';
import useResponsive from 'hooks/responsive';

type MarkTaskAsCompleteButtonProps = {
    taskId: string;
    iconButton?: boolean;
};

const MarkTaskAsCompleteButton: FC<MarkTaskAsCompleteButtonProps> = ({ taskId, iconButton = true }) => {
    const { t } = useTranslation();
    const openModal = useModalStore((s) => s.openModal);
    const task = useTaskById(taskId).data;
    const { isMobile } = useResponsive();
 
    if (!task) {
        return null;
    }

    const { status } = task;

    const openMarkTaskAsCompleteModal = () => {
        openModal({
            defaultValues: {
                activityType: ActivityType.Task,
                id: taskId,
                isAlreadyCompleted: TaskStatus.Completed === status,
            },
            title: t('task-list.mark-task-as-complete'),
            type: ModalType.ActivityReport,
        });
    };

    return (
        <div>
            {iconButton ? (
                <button
                    onClick={openMarkTaskAsCompleteModal}
                    title={t('task-list.mark-task-as-complete')}
                    type="button"
                >
                    <Unchecked />
                </button>
            ) : (
                <Button
                    large={isMobile}
                    onClick={openMarkTaskAsCompleteModal}
                    title={t('task-list.mark-task-as-complete')}
                    type="button"
                    withShadow
                >
                    {t('task-list.mark-task-as-complete')}
                </Button>
            )}
        </div>
    );
};

export default MarkTaskAsCompleteButton;
